module.exports = __webpack_public_path__ + "img/hakone_rope_way.1fc44f77.jpg";